<div class="item-passenger" [ngClass]="{'item-passenger--active': inputCheck.checked}">
  <label class="custom-checkbox">
    <input  type="checkbox" #inputCheck (change)="onSelect(inputCheck.checked)"
      [(ngModel)]="passanger.isSelectForBagagge" />
    <span  class="checkmark"  [ngClass]="{'bg-white': !inputCheck.checked}"></span>
  </label>
  <div class="item-passenger-labels" (click)="onSelect(inputCheck.checked)">
    <div class="item-passenger-labels-title">
      <label class="item-passenger-label-check">
        {{truncateTextUi(passanger.displayName,'26') | titlecase }}
      </label>
    </div>
  </div>
  <app-am-loading [typeLoading]="'COMPONENT_LOADING'" *ngIf="loadingStatusPassenger"></app-am-loading>
</div>
